'use client';
import React from 'react';

const testimonials = [
  {
    name: 'Amara D.',
    location: 'Lagos, NG',
    avatar: '👩🏽',
    rating: 5,
    text: '"Mdeliva changed how I eat. My jollof rice arrives hot every single time. 10/10"',
  },
  {
    name: 'Kevin M.',
    location: 'Nairobi, KE',
    avatar: '👨🏽',
    rating: 5,
    text: '"As a vendor, I doubled my sales in 2 months. The dashboard is super easy to use."',
  },
  {
    name: 'Sophie L.',
    location: 'Accra, GH',
    avatar: '👩🏼',
    rating: 5,
    text: '"Real-time tracking is a game changer. I always know exactly when my food arrives."',
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 px-4">
      <div className="max-w-7xl mx-auto">
        {/* Section Label */}
        <div className="mb-6">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold uppercase tracking-widest bg-[#0a1a0a] border border-[#1a3a1a] text-[#22c55e]">
            LOVED BY CUSTOMERS
          </span>
        </div>

        {/* Heading */}
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-10">
          Real people, real stories.
        </h2>

        {/* Testimonials */}
        <div className="space-y-4">
          {testimonials?.map((t, i) => (
            <div
              key={i}
              className="bg-[#111111] border border-[#1e1e1e] rounded-2xl p-6 flex items-start gap-4"
            >
              {/* Avatar */}
              <div className="w-10 h-10 rounded-full bg-[#222] flex items-center justify-center text-xl flex-shrink-0">
                {t?.avatar}
              </div>

              {/* Content */}
              <div className="flex-1">
                <div className="flex items-center justify-between mb-1">
                  <div>
                    <span className="text-white font-semibold text-sm">{t?.name}</span>
                    <span className="text-gray-500 text-xs ml-2">{t?.location}</span>
                  </div>
                  {/* Stars */}
                  <div className="flex gap-0.5">
                    {Array.from({ length: t?.rating })?.map((_, j) => (
                      <span key={j} className="text-yellow-400 text-xs">★</span>
                    ))}
                  </div>
                </div>
                <p className="text-gray-300 text-sm leading-relaxed">{t?.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
